import { render, staticRenderFns } from "./mag-group.vue?vue&type=template&id=18934794"
import script from "./mag-group.vue?vue&type=script&lang=js"
export * from "./mag-group.vue?vue&type=script&lang=js"
import style0 from "../style/mag-group.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports